'use client';

import { NavigableButton } from '@carvana/ds-button';
import Image from '@/common/Image';
import { appAssetsCdnUrl } from '~/constants/environment';
import { useDealershipConfiguration } from '~/context/dealership/StaticContext';

export default function Service() {
  const metadata = useDealershipConfiguration();

  return (
    <div className="bg-canvas-muted px-2xl py-6xl md:px-3xl md:py-7xl lg:px-4xl">
      <div className="mx-auto flex max-w-[1272px] flex-col items-center justify-between gap-2xl md:flex-row-reverse md:gap-4xl lg:gap-9xl">
        <Image
          src={`${appAssetsCdnUrl}/images/dealership/service.jpg`}
          alt="Service technician working on a car"
          width={506}
          height={339}
          className="rounded-xl"
        />

        <div className="flex flex-col gap-y-2xl md:w-1/2">
          <div className="flex flex-col gap-y-lg">
            <h2 className="text-text-strong t-heading-xl">Expert service</h2>
            <p className="text-text-default t-body-sm">
              From oil changes to engine repairs, our certified techs keep your
              vehicle in peak condition. Trust {metadata.name ?? 'Carvana'} for
              fast, reliable service.
            </p>
          </div>

          <NavigableButton
            size="md"
            variant="primary"
            width="fit-content"
            href="/service"
            data-adobe-id="book-now"
            data-analytics-id="Service"
            data-analytics-attributes={JSON.stringify({ item: 'Book now' })}
            data-testid="book-now"
          >
            Book now
          </NavigableButton>
        </div>
      </div>
    </div>
  );
}
